import apiClient from './apiClient';

export type CommunicationChannel = 'in_app' | 'email' | 'sms' | 'push';

class CommunicationsService {
  async send(payload: {
    client_id: string;
    appointment_id?: string;
    channel: CommunicationChannel;
    content?: string;
    subject?: string;
    template_key?: string;
    variables?: Record<string, string>;
    retry?: boolean;
  }) {
    const res = await apiClient.post('/communications/send', payload);
    return res.data;
  }

  async list(params?: { clientId?: string; appointmentId?: string; status?: string; channel?: CommunicationChannel; limit?: number }) {
    const res = await apiClient.get('/communications', { params });
    return res.data.data;
  }

  async getChannelStatus() {
    const res = await apiClient.get('/communications/channels/status');
    return res.data.data;
  }

  async retry(id: string) {
    const res = await apiClient.post(`/communications/retry/${id}`);
    return res.data;
  }

  async listAttempts(communicationId: string) {
    const res = await apiClient.get(`/communications/${communicationId}/attempts`);
    return res.data.data;
  }

  async listTemplates(channel?: CommunicationChannel) {
    const res = await apiClient.get('/communications/templates', {
      params: channel ? { channel } : undefined,
    });
    return res.data.data;
  }

  async createTemplate(payload: {
    channel: CommunicationChannel;
    template_key: string;
    name: string;
    subject?: string;
    body: string;
    active?: boolean;
  }) {
    const res = await apiClient.post('/communications/templates', payload);
    return res.data.data;
  }

  async updateTemplate(id: string, payload: { name?: string; subject?: string; body?: string; active?: boolean }) {
    const res = await apiClient.patch(`/communications/templates/${id}`, payload);
    return res.data.data;
  }
}

export const communicationsService = new CommunicationsService();
